import {Injectable} from '@angular/core';
import {GenericHandler} from '../generics/generic-handler';
import {FormFieldBaseSupplier} from '../../suppliers/form-fieldbase-supplier';
import {DialogMsgSupplier} from '../../suppliers/dialog-msg-supplier';
import {StockDTO} from '../../dtos/stock-dto';
import {UtilsService} from '../../utils/utils.service';
import {GenericDatagridService} from '../generics/generic-datagrid.service';
import {Auth2Service} from '../security/auth2.service';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Title} from '@angular/platform-browser';
import {catchError} from 'rxjs/operators';
import {UniteDeProduction__zoneDeStockageService} from '../entities/unite-de-production__zone-de-stockage.service';
import {Observable, Subject} from 'rxjs';
import {SearchSupplierWrapper} from '../../suppliers/wrappers/search-supplier-wrapper';
import {ModelViewInventaire} from '../../../gestion-stocks/stocks/inventaire/model-view-inventaire';
import {ModelViewMatierePremiere} from '../../../gestion-stocks/stocks/matieres-premieres/model-view-matiere-premiere';
import * as moment from 'moment';
import {FormFieldDropdownSupplier} from '../../suppliers/form-field-dropdown-supplier';
import {UniteDeProduction__ZoneDeStockageDTO} from '../../dtos/unite-de-production__zone-stockage-dto';
import {FormFieldCurrencySupplier} from "../../suppliers/form-field-currency-supplier";
import {FormFieldCalendarSupplier} from "../../suppliers/form-field-calendar-supplier";

export const URL_GET_PREPARE_SEARCH = `dolrest/gestion-stocks/prepare-search`;
export const URL_POST_SAVE_INVENTAIRE = `dolrest/gestion-stocks/save/inventaire`;
export const URL_POST_SAVE_STOCK = `dolrest/gestion-stocks/ajout/lot`;
export const URL_POST_UPDATE_STOCK = `dolrest/gestion-stocks/update/lot`;


@Injectable({
  providedIn: 'root'
})
export class StocksService extends GenericHandler<StockDTO> {

  private subjectFeature = new Subject<string>();
  public feature$: Observable<string> = this.subjectFeature.asObservable();

  private subjectLoadStocks = new Subject<ModelViewMatierePremiere>();
  public loadStocks$: Observable<ModelViewMatierePremiere> = this.subjectLoadStocks.asObservable();

  private subjectOpenDialogSortie = new Subject<DialogStockSortieSupplier>();
  public openDialogSortie$: Observable<DialogStockSortieSupplier> = this.subjectOpenDialogSortie.asObservable();

  // dialog-confirm-save  component
  private subjectOpenDialogConfirmSave = new Subject<boolean>();
  public openDialogConfirmSave$: Observable<boolean> = this.subjectOpenDialogConfirmSave.asObservable();

  private subjectIsKeepItClose = new Subject<boolean>();
  public isKeepItClose$: Observable<boolean> = this.subjectIsKeepItClose.asObservable();

  private subjectIsConfirmCancelled = new Subject<boolean>();
  public isConfirmCancelled$: Observable<boolean> = this.subjectIsConfirmCancelled.asObservable();

  private subjectOpenDialogEditLot = new Subject<DialogStockSortieSupplier>();
  public openDialogEditLot$: Observable<DialogStockSortieSupplier> = this.subjectOpenDialogEditLot.asObservable();

  constructor(utils: UtilsService,
              private gds: GenericDatagridService, private udpZdsSvc: UniteDeProduction__zoneDeStockageService,
              auth2Svc: Auth2Service, router: Router, http: HttpClient, title: Title) {
    super(utils, auth2Svc, router, http, title);


  }

  createEmptyDTO = (): StockDTO => undefined;

  getAllFromEnvironnement = (): void => {
  };

  getCreateNewObjectLabel = (): string => '';

  getEditObjectLabel = (data: StockDTO): string => '';

  getEntityName = (): string => 'stock';

  getFields = (dto: StockDTO): FormFieldBaseSupplier<any>[] => {
    if (!dto) {
      return [];
    }
    const udpZdsList = this.initUdpZdsList(dto.idUdp);
    const udpZdsSelected = udpZdsList.find(udpZds => udpZds.id === dto.idUdpZoneDeStockage);
    const fields: FormFieldBaseSupplier<any>[] = [
      new FormFieldDropdownSupplier({
        key: 'unitesProductionZonesDeProduction',
        label: 'Zone de stockage',
        optionLabel: 'libelleZoneDeStockage',
        readonly: !this.canModify(dto),
        type: 'singleListBox',
        value: this.utils.preSelectSingleList(udpZdsList, udpZdsSelected),
        order: 1,
        options: udpZdsList,
        width: 300,
        required: true,
      }),

      new FormFieldCurrencySupplier({
        key: 'quantite',
        label: 'Quantité',
        width: 150,
        type: 'number',
        suffix: dto.udmStockLibelle,
        value: dto.quantite,
        required: true,
        order: 2
      }),

      new FormFieldCurrencySupplier({
        key: 'prixUnitaire',
        label: 'PU H.T en UF',
        width: 150,
        type: 'number',
        suffix: '€/' + dto.udmFacturationLibelle,
        value: dto.prixUnitaire,
        required: true,
        order: 3
      }),

      new FormFieldCalendarSupplier({
        key: 'dateEntree',
        label: 'Date Entrée',
        value: new Date(dto.dateEntree),
        dateFormat: 'dd/mm/yy',
        required: true,
        showTime: false,
        order: 4
      })

    ];
    return fields;
  };

  initUdpZdsList = (idUdp: number): UniteDeProduction__ZoneDeStockageDTO[] => {
    const udpZdsList = this.udpZdsSvc.udpZdsListEnvironnement;
    if (this.utils.isCollectionNullOrEmpty(udpZdsList)) {
      return [];
    }
    return udpZdsList.filter(item => item.idUniteDeProduction === idUdp);
  };

  getHelp = (): DialogMsgSupplier => undefined;

  getOas = (): boolean => false;

  getSort = (): string[] => [];

  getTitle = (): string => 'GESTION DES STOCKS';

  getTotalRecordsLabel = (): string => '';

  prepareSearch = () => {
    return this.http.get(URL_GET_PREPARE_SEARCH)
      .pipe(
        catchError(error => this.utils.handleError(error))
      );

  };


  announceFeature = (feature: string) => {
    this.subjectFeature.next(feature);
  };

  public announceIsKeepItClose = (isKeepItClose: boolean) => {
    this.subjectIsKeepItClose.next(isKeepItClose);
  };

  public announceOpenDialogConfirmSave = (displayDialog: boolean) => {
    this.subjectOpenDialogConfirmSave.next(displayDialog);
  };

  public annonceIsConfirmCancelled = (IsConfirmCancelled: boolean) => {
    this.subjectIsConfirmCancelled.next(IsConfirmCancelled);
  };

  public announceOpenDialogEditLot = (selectedMatierePremiere: ModelViewMatierePremiere, stockDTO: StockDTO) => {
    this.subjectOpenDialogEditLot.next(new DialogStockSortieSupplier(stockDTO, null, selectedMatierePremiere));
  };


  saveInventaire = (lignesInventaire: ModelViewInventaire[]) => {
    return this.http.post(URL_POST_SAVE_INVENTAIRE, lignesInventaire)
      .pipe(
        catchError(error => this.utils.handleError(error))
      );

  };

  saveStock = (stock: StockDTO) => {
    return this.http.post(URL_POST_SAVE_STOCK, stock)
      .pipe(
        catchError(error => this.utils.handleError(error))
      );

  };

  updateStock = (stock: StockDTO) => {
    return this.http.post(URL_POST_UPDATE_STOCK, stock)
      .pipe(
        catchError(error => this.utils.handleError(error))
      );
  };


  announceOpenDialogSortie = (ssw: SearchSupplierWrapper, selectedStock: StockDTO, matierePremiere: ModelViewMatierePremiere) => {
    const dsss = new DialogStockSortieSupplier(selectedStock, ssw, matierePremiere);
    this.subjectOpenDialogSortie.next(dsss);
  };

  announceLoadStocks = (matierePremiere: ModelViewMatierePremiere) => {
    this.subjectLoadStocks.next(matierePremiere);
  };


  /**
   * si champ de recherhce 'Périmé le ' renseigné, on prend cette date
   * sinon on prend la date du jour pour considerer que le stock est périmé
   * @param dlc
   */
  isPerime = (dlc: Date | number, ssw: SearchSupplierWrapper) => {

    let datePerime = new Date();

    if (!this.utils.isNullOrEmpty(ssw)
      && !this.utils.isNullOrEmpty(ssw.filtersMap['PERIME_LE'])
    ) {
      datePerime = ssw.filtersMap['PERIME_LE'].value;
    }

    return moment(dlc).isBefore(moment(datePerime), 'days');

  };

}

export class DialogStockSortieSupplier {

  selectedStock: StockDTO;
  ssw: SearchSupplierWrapper;
  matierePremiere: ModelViewMatierePremiere;


  constructor(selectedStock: StockDTO, ssw: SearchSupplierWrapper, matierePremiere: ModelViewMatierePremiere) {
    this.selectedStock = selectedStock;
    this.ssw = ssw;
    this.matierePremiere = matierePremiere;
  }
}
